var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTellor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 54,
    viewBox: "0 0 193 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 23.04H23.48V13.87H15.78V3.58H5.42V13.87H0.73V23.04H5.42V44.39C5.42 52.51 10.39 53.98 18.51 53.98C19.98 53.98 21.94 53.84 23.2 53.7V44.88C22.57 44.95 21.73 45.02 20.54 45.02C15.85 45.02 15.78 41.38 15.78 39.28V23.04ZM50.6509 53.98C61.9209 53.98 67.1009 47.12 68.6409 45.02L60.5209 40.33C59.3309 41.66 56.4609 44.81 50.6509 44.81C48.5509 44.81 41.4109 44.11 40.1509 37.81H70.5309C70.5309 37.81 70.7409 35.92 70.7409 32.98C70.3909 20.59 60.5209 13.87 50.6509 13.87C43.4409 13.87 29.7209 18.07 29.7209 33.89C29.7209 49.71 43.1609 53.98 50.6509 53.98ZM50.5809 23.04C55.8309 23.04 59.2609 26.89 59.6809 30.39H40.4309C40.8509 26.47 44.5609 23.04 50.5809 23.04ZM79.2574 53H89.7574V0.0799971H79.2574V53ZM99.8336 53H110.334V0.0799971H99.8336V53ZM139.38 53.91C150.86 53.91 160.38 44.95 160.38 33.82C160.38 22.83 150.86 13.8 139.38 13.8C127.9 13.8 118.52 22.83 118.52 33.82C118.52 44.95 127.9 53.91 139.38 53.91ZM139.38 22.97C145.33 22.97 149.95 27.66 149.95 33.82C149.95 40.05 145.33 44.81 139.38 44.81C133.36 44.81 128.81 40.19 128.81 33.82C128.81 27.73 133.5 22.97 139.38 22.97ZM192.393 24.02V13.8C189.663 13.73 183.153 14.43 179.233 19.61V14.5H168.803V53H179.233V35.99C179.233 24.3 189.873 23.81 192.393 24.02Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellor);
export default __webpack_public_path__ + "static/media/tellor.a85cc955.svg";
export { ForwardRef as ReactComponent };